import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  blockFailed: {
    id: 'authoring.problemEditor.blockFailed',
    defaultMessage: 'Problem failed to load',
    description: 'Error message for problem block failing to load',
  },
});

export default messages;
